import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  executesihtib9b5qrj as execute,
  ActionPipe2nmxwvx2ocjhz as ActionPipe,
} from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionPipe.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SuspendAction33643gogpgl0e as SuspendAction } from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/async/SuspendAction.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  logAsync1htj4sqob9uhi as logAsync,
  ActionLoggingSyntax2p3dfvwppstk6 as ActionLoggingSyntax,
} from './ActionLoggingSyntax.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KotlinLogging_getInstance36i5tmdcg9bhr as KotlinLogging_getInstance } from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/KotlinLogging.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_theLogger() {
  _init_properties_LoggingActionPipe_kt__jmuje7();
  var tmp0 = theLogger$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('theLogger', 0, tmp, _get_theLogger_$ref_r8fuo1(), null);
  return tmp0.n3();
}
var theLogger$delegate;
var LoggingActionPipe$execute$slambdaClass;
function LoggingActionPipe$execute$slambda() {
  if (LoggingActionPipe$execute$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $dispatcher, $action) {
        this.l2j_1 = this$0;
        this.m2j_1 = $dispatcher;
        this.n2j_1 = $action;
      }
      *o2j(it, $completion) {
        return yield* execute.call(this.l2j_1, this.m2j_1, this.n2j_1, $completion);
      }
      ld(p1, $completion) {
        return this.o2j((!(p1 == null) ? isInterface(p1, SuspendAction()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LoggingActionPipe$execute$slambdaClass = $;
  }
  return LoggingActionPipe$execute$slambdaClass;
}
function LoggingActionPipe$execute$slambda_0(this$0, $dispatcher, $action) {
  var i = new (LoggingActionPipe$execute$slambda())(this$0, $dispatcher, $action);
  var l = (it, $completion) => i.o2j(it, $completion);
  l.$arity = 1;
  return l;
}
var LoggingActionPipeClass;
function LoggingActionPipe() {
  if (LoggingActionPipeClass === VOID) {
    class $ {
      constructor(traceId) {
        this.p2j_1 = traceId;
        this.q2j_1 = get_theLogger();
      }
      c2j() {
        return this.p2j_1;
      }
      b2j() {
        return this.q2j_1;
      }
      *z2e(dispatcher, action, $completion) {
        var tmp;
        try {
          tmp = yield* this.d2j(action, LoggingActionPipe$execute$slambda_0(this, dispatcher, action), $completion);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var bad = $p;
            this.q2j_1.g2g(bad, () => 'Error executing ' + getKClassFromExpression(action).j1());
            throw bad;
          } else {
            throw $p;
          }
        }
        return tmp;
      }
    }
    protoOf($).d2j = logAsync;
    initMetadataForClass($, 'LoggingActionPipe', VOID, VOID, [ActionPipe(), ActionLoggingSyntax()], [2]);
    LoggingActionPipeClass = $;
  }
  return LoggingActionPipeClass;
}
function theLogger$delegate$lambda() {
  _init_properties_LoggingActionPipe_kt__jmuje7();
  return KotlinLogging_getInstance().n2f('ActionLogger');
}
function _get_theLogger_$ref_r8fuo1() {
  return () => get_theLogger();
}
var properties_initialized_LoggingActionPipe_kt_pe2ral;
function _init_properties_LoggingActionPipe_kt__jmuje7() {
  if (!properties_initialized_LoggingActionPipe_kt_pe2ral) {
    properties_initialized_LoggingActionPipe_kt_pe2ral = true;
    theLogger$delegate = lazy(theLogger$delegate$lambda);
  }
}
//region block: exports
export {
  LoggingActionPipe as LoggingActionPipenpslk1461eyq,
};
//endregion

//# sourceMappingURL=LoggingActionPipe.mjs.map
